
import _ from 'lodash'
import { applicationOptions, typeOptions, quantityOptions } from '@/helpers/options'
import { calculate, roundTo, lbs2kg } from '@vervocity/tire-pressure-calculations'
import { lswExceptions, lswExceptionsMarked } from '@vervocity/tire-pressure-calculations/lookup-tables'

const applicationOptionsFiltered = (state, getters) => {
    return _.filter(applicationOptions, item => getters.typeBase === item.type)
}

const applicationOptionsAvailable = (state, getters) => _.chain(getters.applicationOptionsFiltered)
    .map(item => _.chain(item)
        .get('options')
        .map(option => _.set(option, 'speed', item.text))
        .value()
    )
    .flatten()
    .value()

const applicationSelected = (state, getters) => {
    return _.find(getters.applicationOptionsAvailable, { value: state.data.application })
}

const applicationText = (state, getters) => _.get(getters.applicationSelected, 'text')

const applicationSpeed = (state, getters) => _.get(getters.applicationSelected, 'speed')

const calculation = (state, getters) => {
    return (getters.canCalculate) ? calculate(getters.tire) : {}
}

const canCalculate = (state, getters) => {
    return _.every(getters.tire, item => _.chain(item).toString().trim().value() !== '')
}

const typeSelected = (state) => _.find(typeOptions, { value: state.data.type })
const typeBase = (state, getters) => _.get(getters.typeSelected, 'base')
const typeText = (state, getters) => _.get(getters.typeSelected, 'text')

const quantitySelected = (state) => _.find(quantityOptions, { value: state.data.quantity })
const quantityText = (state, getters) => _.get(getters.quantitySelected, 'text')

const hasValidCalculations = (state, getters) => {
    return _.toSafeInteger(getters.psi) > 0
}

const psi = (state, getters) => _.get(getters, 'calculation.psi')
const kpa = (state, getters) => _.get(getters, 'calculation.kpa')
const maxLbs = (state, getters) => _.get(getters, 'calculation.lbs')
const maxKg = (state, getters) => roundTo(lbs2kg(getters.maxLbs), 5)

const tire = (state, getters) => ({
    width: state.data.width,
    aspectRatio: state.data.aspectRatio,
    diameter: state.data.diameter,
    axleWeight: state.data.axleWeight,
    type: state.data.type,
    application: state.data.application,
    quantity: state.data.quantity,
    baseType: getters.typeBase,
    loadIndex: state.data.loadIndex,
})

const size = (state) => `${state.data.width}/${state.data.aspectRatio}R${state.data.diameter}`

const humanTire = (state, getters) => ({
    size: getters.size,
    type: getters.typeText,
    application: getters.applicationText,
    axleWeight: state.data.axleWeight,
    quantity: getters.quantityText,
    loadIndex: state.data.loadIndex,
})

const isLsw = (state, { typeBase }) => {
    return _.startsWith(typeBase, 'LSW')
}

const isLswException = (state, { isLsw, size }) => {
    return (isLsw) ? _.includes(lswExceptions, size) : false
}

const isLswExceptionMarked = (state, { isLswException, size }) => {
    return (isLswException) ? _.includes(lswExceptionsMarked, size) : false
}

export default {
    applicationOptionsAvailable,
    applicationOptionsFiltered,
    applicationSelected,
    applicationSpeed,
    applicationText,
    calculation,
    canCalculate,
    hasValidCalculations,
    humanTire,
    isLsw,
    isLswException,
    isLswExceptionMarked,
    kpa,
    maxKg,
    maxLbs,
    psi,
    quantitySelected,
    quantityText,
    size,
    tire,
    typeBase,
    typeSelected,
    typeText,
}
